import React, { Component } from 'react';
import { connect } from 'react-redux';

import Modal from '../../../../../components/Modal';
import LoadMask from '../../../../../components/LoadMask';
import SuggestionForm from './SuggestionForm';

import { getSendSuggestionUI } from '../../../../../redux/selectors';
import { sendSuggestion } from '../../../../../redux/suggestion';

import './styles.css';

class SuggestionModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successMessage: null,
    };
  }

  _submit = ({ suggestionText }) => {
    const { dispatch } = this.props;

    dispatch(sendSuggestion(suggestionText)).then(
      () => {
        this.setState({ successMessage: 'Sugestão enviada com sucesso!' });
      },
      // reject
      () => {},
    );
  };

  render() {
    const { onDismiss, ui } = this.props;
    const { successMessage } = this.state;

    return (
      <Modal
        className="SuggestionModal"
        size="small"
        onBackdropClick={onDismiss}
      >
        <SuggestionForm
          successMessage={successMessage}
          errorMessage={ui.error}
          onSubmit={this._submit}
          onDismiss={onDismiss}
        />
        {ui.isFetching && <LoadMask text="Enviado..." />}
      </Modal>
    );
  }
}

// Redux
const mapStateToProps = state => ({
  ui: getSendSuggestionUI(state),
});

export default connect(mapStateToProps)(SuggestionModal);
